import { TraitIcon } from "./trait-icon";
import { filterTraits } from "@/lib/utils/trait-icons";
import { Badge } from "@/components/ui/badge";

interface TraitBadgeListProps {
  specialities: string[];
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function TraitBadgeList({ 
  specialities, 
  size = "md",
  className = "" 
}: TraitBadgeListProps) {
  if (!specialities || specialities.length === 0) {
    return null;
  }

  const traits = filterTraits(specialities);
  const nonTraits = specialities.filter(spec => !spec.startsWith("_"));

  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {/* Display trait icons */}
      {traits.map((trait, index) => (
        <TraitIcon key={`trait-${index}`} speciality={trait} size={size} />
      ))}
      {/* Display non-trait specialities as badges */}
      {nonTraits.map((speciality, index) => (
        <Badge key={`speciality-${index}`} variant="secondary">
          {speciality}
        </Badge>
      ))}
    </div>
  );
}

